import type { ApmBase } from '@elastic/apm-rum';
import { init as initApm } from '@elastic/apm-rum';

type RumInitConfig = {
  apmUrl: string;
  env: string;
  serviceName?: string;
  serviceVersion?: string;
};

let apmInstance: ApmBase | null = null;

export const initRum = ({
  apmUrl,
  env,
  serviceName = 'autoops-react-app',
  serviceVersion,
}: RumInitConfig): ApmBase | null => {
  if (!apmUrl) {
    return null;
  }

  if (apmInstance) {
    return apmInstance;
  }

  try {
    apmInstance = initApm({
      serviceName,
      serverUrl: apmUrl,
      environment: env,
      serviceVersion,
    });

    return apmInstance;
  } catch {
    // Swallow initialization errors so that a misconfigured RUM setup
    // never prevents the application from starting.
    return null;
  }
};

export const getRum = (): ApmBase | null => apmInstance;
